"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PtoRequestsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const List_1 = __importDefault(require("../components/List"));
const Field_1 = __importDefault(require("../components/Field"));
const react_native_paper_1 = require("react-native-paper");
const react_native_1 = require("react-native");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_i18next_1 = require("react-i18next");
const Loading_1 = __importDefault(require("../components/Loading"));
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Helper_1 = require("../Helper");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const Button_1 = __importDefault(require("../components/Button"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        pendingLabel: {
            backgroundColor: `${THEME.Amber}AD`,
            borderRadius: 2,
            marginVertical: 4,
            marginHorizontal: 4,
            paddingHorizontal: 6,
            paddingVertical: 2
        },
        pendingLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        approvedLabel: {
            backgroundColor: THEME.Secondary,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        approvedLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        deniedLabel: {
            backgroundColor: THEME.Red,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        deniedLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        unknownLabel: {
            backgroundColor: THEME.NeutralGray,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        unknownLabelText: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 12 : 10,
            fontWeight: '500'
        }
    });
};
function PtoRequestItem(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const [expanded, setExpanded] = react_1.default.useState(false);
    const [isCancelling, setIsCancelling] = react_1.default.useState(false);
    const onCancelPress = async () => {
        if (isCancelling)
            return;
        setIsCancelling(true);
        try {
            const ok = await props.cancel(props.item.requestId, props.item.accountId);
            if (!ok)
                setIsCancelling(false);
        }
        catch {
            setIsCancelling(false);
        }
    };
    const description = (request) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight, fontSize: size != 'sm' ? 14 : 12 }, children: request.totalHours + ' ' + t('time:text.hours') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight, fontSize: size != 'sm' ? 14 : 12 }, children: " " + request.registerDescription })] }));
    const formatDate = (dateString) => {
        const showYear = new Date(dateString).getFullYear() != new Date().getFullYear() || true;
        return new Date(dateString).toLocaleDateString(Helper_1.Helper.deviceLanguage(), { month: 'short', ...showYear ? { year: "numeric" } : null, day: 'numeric', timeZone: 'UTC' });
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, justifyContent: 'flex-start' }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.List.Accordion, { titleNumberOfLines: 2, titleStyle: { color: THEME.Text, fontSize: size != 'sm' ? 16 : 14, fontWeight: '500' }, title: formatDate(props.item.startDate) + (props.item.startDate == props.item.endDate ? '' : ' — ' + formatDate(props.item.endDate)), description: description(props.item), left: (props) => (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: expanded ? Theme_1.ICONS.Regular.ChevronUp : Theme_1.ICONS.Regular.ChevronDown, size: 16, color: THEME.Text, style: { marginHorizontal: 8, alignSelf: 'center' } }), right: () => (props.item.status == 'Pending' &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.pendingLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.pendingLabelText, children: t("time:text.pending").toUpperCase() }) }) || props.item.status == 'Denied' &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.deniedLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.deniedLabelText, children: t("time:text.denied").toUpperCase() }) }) || props.item.status == 'Approved' &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.approvedLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.approvedLabelText, children: t("time:text.approved").toUpperCase() }) }) ||
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.unknownLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unknownLabelText, children: props.item.status.toUpperCase() }) })), expanded: expanded, onPress: () => setExpanded(!expanded), theme: { colors: { background: 'transparent' } }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 0, paddingLeft: 0, marginHorizontal: 0, marginBottom: 18, marginTop: 6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.OffWhite, borderRadius: 4 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, paddingTop: 0 }, children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { borderTopLeftRadius: 4, borderTopRightRadius: 4 }, columns: [
                                        { flex: 1, label: t('myPay:text.date'), align: 'center' },
                                        { flex: 1, label: t('myPay:text.amt'), align: 'center' }
                                    ] }), props.item.ptoDays.map((details, index) => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, style: { flexDirection: 'row', justifyContent: 'center', marginVertical: 6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { fontSize: size != 'sm' ? 14 : 12, fontWeight: '400', color: THEME.Text }, children: formatDate(details.requestDate) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { fontSize: size != 'sm' ? 14 : 12, color: THEME.Text }, children: details.hours + ' ' + t('time:text.hours') }) })] }, index)))] }) }), !!props.item.comment &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.OffWhite, borderRadius: 4 }, children: (0, jsx_runtime_1.jsx)(Field_1.default, { style: { padding: 12 }, caption: t('time:text.comments'), value: props.item.comment ? props.item.comment : "—" }) }), props.item.status !== 'Approved' &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignSelf: 'stretch', width: '100%' }, children: [props.item.status === 'Pending' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginRight: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('time:buttons.edit'), type: 'solid', onPress: () => { if (!isCancelling)
                                            props.onEdit(props.item); }, disabled: isCancelling, style: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: isCancelling ? THEME.TextDisabled : THEME.White, icon: Theme_1.ICONS.Regular.Pen, size: size != 'sm' ? 14 : 12 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { color: isCancelling ? THEME.TextDisabled : THEME.White, fontSize: (size != 'sm' ? 14 : 12), fontWeight: '500', marginLeft: 6 }, children: t('time:buttons.edit') })] }) })), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('time:buttons.cancel'), type: 'outline', onPress: onCancelPress, disabled: isCancelling, style: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: isCancelling ? THEME.TextDisabled : THEME.Primary, icon: Theme_1.ICONS.Regular.Xmark, size: size != 'sm' ? 14 : 12 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { color: isCancelling ? THEME.TextDisabled : THEME.Primary, fontSize: (size != 'sm' ? 14 : 12), fontWeight: '500', marginLeft: 6 }, children: t('time:buttons.cancel') })] }) })] })] }) }) }));
}
;
function PtoRequestsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [requests, setRequests] = react_1.default.useState(null);
    const inFlightCancel = react_1.default.useRef(new Set());
    const onOpenEdit = react_1.default.useCallback((it) => {
        if (userContext.isImpersonated) {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                type: "warning",
                message: t('common:messages.impersonatedUser')
            });
            return;
        }
        props.navigation.navigate('PtoRequestEdit', { requestId: it.requestId });
    }, [props.navigation, t, userContext.isImpersonated]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
            TimeAttendance_1.default.getEmployeePtoRequests(token, null, null).then(data => {
                setRequests(data);
                setStatus('done');
            });
        }).catch(e => {
            setRequests(null);
            setStatus((e == 404) ? 'done' : 'error');
        }));
    }, []);
    const cancel = react_1.default.useCallback(async (requestId, accountId) => {
        if (inFlightCancel.current.has(requestId))
            return false;
        inFlightCancel.current.add(requestId);
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            feature: 'Cancel PTO Request',
            client: userContext.client?.id,
            employee: userContext.employee?.employeeId
        });
        try {
            promise.current?.cancel();
            const token = await userContext.getToken();
            const response = await TimeAttendance_1.default.cancelPTORequest(token, { requestId, accountId });
            if (response?.success) {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t('time:messages.ptoRequestCancelSuccess') });
                react_native_1.DeviceEventEmitter.emit("event.ptoRequestUpdate");
                return true;
            }
            else {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('time:messages.ptoRequestCancelError') });
                return false;
            }
        }
        catch {
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('time:messages.ptoRequestCancelError') });
            return false;
        }
    }, [t, userContext]);
    react_1.default.useEffect(() => {
        refresh();
        react_native_1.DeviceEventEmitter.addListener("event.ptoRequestUpdate", () => refresh());
        return () => {
            react_native_1.DeviceEventEmitter.removeAllListeners("event.ptoRequestUpdate");
            promise.current?.cancel();
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { "aria-label": t('time:headers.ptoRequests'), title: t('time:headers.ptoRequests'), style: { marginBottom: 8 } }), (0, jsx_runtime_1.jsx)(List_1.default, { data: requests, keyExtractor: (item, index) => item.requestId, itemSeparator: () => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator] })), renderItem: (item, index) => ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { flexGrow: 1, justifyContent: 'space-between', flexDirection: 'row' }, children: (0, jsx_runtime_1.jsx)(PtoRequestItem, { item: item, cancel: (requestId, accountId) => cancel(requestId, accountId), onEdit: (it) => onOpenEdit(it) }) }, item.requestId)), listEmpty: () => (status == 'done')
                        &&
                            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.IslandTropical, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'center', fontSize: (size != 'sm' ? 16 : 14), color: THEME.TextNull }, children: t('time:messages.noRequests') })] })
                        ||
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }) })] }) }));
}
